import { render, staticRenderFns } from "./detail_result.vue?vue&type=template&id=e8daa6be&scoped=true&"
import script from "./detail_result.vue?vue&type=script&lang=js&"
export * from "./detail_result.vue?vue&type=script&lang=js&"
import style0 from "./detail_result.vue?vue&type=style&index=0&id=e8daa6be&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8daa6be",
  null
  
)

export default component.exports